export const FELSVEnvironmentEnum = {
  TEST: 1,
  PRODUCTION: 2,
}

export const felSVEnvironmentsOptions = [
  {
    value: FELSVEnvironmentEnum.TEST,
    label: 'Pruebas',
  },
  {
    value: FELSVEnvironmentEnum.PRODUCTION,
    label: 'Producción',
  },
]
